// ConfirmDialog.jsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Slide,
} from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmDialog = ({
  open,
  title,
  content,
  contentText,
  onSave,
  onClose,
  saveButtonName = '확인',
  closeButtonName = '취소',
  useSaveButton = true,
  useCloseButton = true,
}) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      BackdropProps={{
        style: {
          zIndex: 1399, // backdrop z-index
        },
      }}
      PaperProps={{
        sx: {
          zIndex: 1400, // Dialog Paper z-index
        },
      }}
      sx={{
        zIndex: 1400, // Dialog root z-index
      }}
    >
      {title && <DialogTitle>{title}</DialogTitle>}

      <DialogContent>
        {content && <div>{content}</div>}
        {contentText && <DialogContentText>{contentText}</DialogContentText>}
      </DialogContent>

      <DialogActions>
        {useCloseButton && (
          <Button onClick={onClose} color="inherit">
            {closeButtonName}
          </Button>
        )}
        {useSaveButton && (
          <Button onClick={onSave} color="error" variant="contained">
            {saveButtonName}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
